import { useId, useMemo } from 'react';
import {
    CLASS_DAYS,
    sortDays,
} from './timePickerUtils';
import './TimePickerModern.css';

const normalizeDays = (days = []) =>
    sortDays(
        days
            .map((day) => CLASS_DAYS.find((item) => item.id === day.id) || day)
            .filter((day) => CLASS_DAYS.some((item) => item.id === day.id)),
    );

/**
 * Fila de días L–S para selección rápida (sin panel).
 *
 * @param {{
 *   value?: Array<{id:number,day?:string,simbolo?:string}>,
 *   onChange: (days: Array<{id:number,day:string,simbolo:string}>) => void,
 *   label?: string,
 *   disabled?: boolean,
 *   className?: string,
 *   error?: string|null,
 *   required?: boolean,
 * }} props
 */
export const ClassDaysPickerModern = ({
    value = [],
    onChange,
    label = 'Días de clase',
    disabled = false,
    className = '',
    error = null,
    required = false,
}) => {
    const generatedId = useId();
    const groupId = `class-days-${generatedId}`;
    const selectedDays = useMemo(() => normalizeDays(value), [value]);

    const toggleDay = (day) => {
        if (disabled) return;
        const isSelected = selectedDays.some((item) => item.id === day.id);
        const next = isSelected
            ? selectedDays.filter((item) => item.id !== day.id)
            : sortDays([...selectedDays, day]);
        onChange(next);
    };

    return (
        <div className={`time-picker ${className}`.trim()}>
            {label ? (
                <p id={`${groupId}-label`} className="time-picker__label">
                    {label}
                    {required ? (
                        <span className="time-picker__required" aria-hidden="true">*</span>
                    ) : null}
                </p>
            ) : null}

            <div
                className="time-picker__days"
                style={{ marginBottom: 0 }}
                role="group"
                aria-labelledby={label ? `${groupId}-label` : undefined}
                aria-label={label || 'Días de clase'}
            >
                {CLASS_DAYS.map((day) => {
                    const isSelected = selectedDays.some((item) => item.id === day.id);
                    return (
                        <button
                            key={day.id}
                            type="button"
                            className="time-picker__day-btn"
                            data-selected={isSelected}
                            aria-pressed={isSelected}
                            aria-label={day.day}
                            disabled={disabled}
                            onClick={() => toggleDay(day)}
                        >
                            {day.simbolo}
                        </button>
                    );
                })}
            </div>

            {error ? (
                <p className="time-picker__error" role="alert">
                    {error}
                </p>
            ) : null}
        </div>
    );
};
